export default "__VITE_ASSET__C2wAciEj__"